import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { queryKeys } from '../../queryKeys.ts';
import type { RcmTableParams } from '../../queries/rcm/keys.ts';
import { fetchRcmTablePage } from '../../request/rcm/functional.js';

export type RcmTablePageView = Awaited<ReturnType<typeof fetchRcmTablePage>>;

export function useRcmTablePage(params: RcmTableParams, options?: { enabled?: boolean }): UseQueryResult<RcmTablePageView, Error> {
  return useQuery({
    queryKey: queryKeys.rcm.table(params),
    queryFn: () => fetchRcmTablePage(params),
    placeholderData: keepPreviousData,
    enabled: options?.enabled !== false,
  });
}
